// extracted by mini-css-extract-plugin
export default {"emoji":"emoji__1REkI","emoji__img":"emoji__img__3wAje","emoji__native":"emoji__native__1kach","fade-in":"fade-in__QALB3","fade-out":"fade-out__BFU5O"};